import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";
import { BrowserRouter } from "react-router-dom";
import AuthProvider from "./context/AuthContext";
import SubmissionDraftProvider from "./context/SubmissionDraftContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <SubmissionDraftProvider>
        <App />
      </SubmissionDraftProvider>
    </AuthProvider>
  </BrowserRouter>
);
